import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { NewInvitationActions } from './new-invitation.actions';
import { NewInvitationSelectors } from './new-invitation.selectors';

@Injectable({ providedIn: 'root' })
export class NewInvitationStore {
  state$ = this.store.select(NewInvitationSelectors.getState());

  constructor(private store: Store) {}

  createInvitationInit(): void {
    this.store.dispatch(NewInvitationActions.createInvitationInit());
  }

  createInvitation(request: { gatewaySerial: string; comment?: string }): void {
    this.store.dispatch(
      NewInvitationActions.createInvitation({
        request,
      })
    );
  }
}
